export const isEmptyObjectValues = (object: Record<string | number, unknown>) => {
	return Object.keys(object).every((key) => object[key] === '');
};
